import { render, staticRenderFns } from "./tabOffice.vue?vue&type=template&id=6e97855e&scoped=true"
import script from "./tabOffice.vue?vue&type=script&lang=js"
export * from "./tabOffice.vue?vue&type=script&lang=js"
import style0 from "./tabOffice.vue?vue&type=style&index=0&id=6e97855e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e97855e",
  null
  
)

export default component.exports